import React from 'react';
import './ButtonRolesAction.css';
const ButtonRolesAction = ({onClick, children, className}) => {
  return (
    <button onClick={onClick} className={`ButtonRolesAction ${className}`}>
      {children}
    </button>
  );
};

export default ButtonRolesAction;
